export default "__VITE_ASSET__a2d06b4c__"